import * as React from "react";
import _, { find } from "lodash";
import { SidingType, SidingColor, SidingArea, SidingSupportedConfigurations, typeNameMap } from "./colors";
import { Dropdown, DropdownItemProperties } from "./dropdown";
import ColorChooser from "./color-chooser";
import { ColorizerState, ConfiguredArea } from "./colorizer-state";

interface ColorizerControlProperties extends React.Props<ColorizerControlProperties> {
    area: SidingArea;
    configs: SidingSupportedConfigurations[];
    onSettingsChanged: (area: ConfiguredArea) => void;
    selectedType: SidingType;
    selectedColor: SidingColor;
}

class ColorizerControl extends React.Component<ColorizerControlProperties, ConfiguredArea> {

    constructor(props: ColorizerControlProperties) {
        super(props);
        this.state = new ConfiguredArea(props.selectedColor, props.selectedType);
    }
    colorChanged(color: SidingColor) {
        let newState = new ConfiguredArea(color, this.state.SidingType);
        this.setState(newState);
        this.props.onSettingsChanged(newState);
    }

    colorsFor(type: SidingType) {
        const match = find(this.props.configs, config => config.SidingType === type);

        if(!match)
            return [];

        return match.Colors;
    }

    typeChanged(type: SidingType) {
        let newState = new ConfiguredArea(this.state.SelectedColor, type);
        let supportedColors = this.colorsFor(type);

        if(!find(supportedColors, color => color === this.state.SelectedColor)) {
            newState.SelectedColor = supportedColors[0]
        }

        this.setState(newState);
        this.props.onSettingsChanged(newState);
    }

    typesFor(area: SidingArea): SidingType[]  {
        return this.props.configs.map((config) => { return config.SidingType; });
    }

    render() {
        return (<div className="colorizer-control">
            <Dropdown options={this.typesFor(this.props.area)} enabled={ this.props.area !== SidingArea.Trim } onItemSelected={this.typeChanged.bind(this)} title={ this.props.area === SidingArea.Trim ? "Soffit/Fascia" : typeNameMap(this.props.selectedType) }/>
            <ColorChooser onClick={this.colorChanged.bind(this)} colors={ this.colorsFor(this.state.SidingType)} selected={ this.state.SelectedColor }/>
        </div>)
    }
}


interface ColorizerControlPanelProperties extends React.Props<ColorizerControlPanelProperties> {
    areas: SidingSupportedConfigurations[][];
    onSettingsChanged: (area: SidingArea, newState: ConfiguredArea) => void;
    initialState: ColorizerState;
}

interface ControlPanelState {
    sharePanelOpen: boolean;
    initialState: ColorizerState;
}


export class ColorizerControlPanel extends React.Component<ColorizerControlPanelProperties, ControlPanelState> {

    constructor(props: ColorizerControlPanelProperties) {
        super(props);
        this.state = {
            initialState: props.initialState,
            sharePanelOpen: false
        };
    }

    toggleShare() {
        this.setState({
            sharePanelOpen: !this.state.sharePanelOpen,
            initialState: this.state.initialState
        });
    }

    shareUrl() {
        return window.location.protocol + "//" + window.location.host + window.location.pathname + "#" + ColorizerState.codeFor(this.props.initialState);
    }

    emailUrl() {
        return "mailto:?subject=" + this.shareUrl() + "&body=" + this.shareUrl();
    }

    supportsSMS() {
        return this.isAndroid() || this.isIOS();
    }

    isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window["MSStream"];
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    smsUrl() {
        var connector = this.isAndroid() ? "?" : "&";
        return ["sms:", "body=" + this.shareUrl()].join(connector);
    }

    render() {
        return (
          <div className="colorizer-controls">
             <ColorizerControl configs={ this.props.areas[SidingArea.Trim] } onSettingsChanged={ this.props.onSettingsChanged.bind(null, SidingArea.Trim) } area={SidingArea.Trim} selectedColor={this.state.initialState.Trim.SelectedColor} selectedType={this.state.initialState.Trim.SidingType} />
             <ColorizerControl configs={ this.props.areas[SidingArea.B] } onSettingsChanged={ this.props.onSettingsChanged.bind(null, SidingArea.B) } area={SidingArea.B}  selectedColor={this.state.initialState.AreaB.SelectedColor} selectedType={this.state.initialState.AreaB.SidingType}/>
             <ColorizerControl configs={ this.props.areas[SidingArea.C] } onSettingsChanged={ this.props.onSettingsChanged.bind(null, SidingArea.C) } area={SidingArea.C}  selectedColor={this.state.initialState.AreaC.SelectedColor} selectedType={this.state.initialState.AreaC.SidingType}/>
             <ColorizerControl configs={ this.props.areas[SidingArea.A] } onSettingsChanged={ this.props.onSettingsChanged.bind(null, SidingArea.A) } area={SidingArea.A}  selectedColor={this.state.initialState.AreaA.SelectedColor} selectedType={this.state.initialState.AreaA.SidingType}/>
             <button className="btn btn-print" onClick={() => window.print()}>Print</button>
             <button className="btn btn-share" onClick={this.toggleShare.bind(this)}>Share</button>
             <div style={{ display: this.state.sharePanelOpen ? "block" : "none" }}>
                <a href={this.emailUrl()} className="fa fa-envelope"> <span>Email</span> </a>
                <a href={this.smsUrl()} style={{ display: this.supportsSMS() ? "block" : "none" }} className="fa fa-comments"> <span>SMS</span> </a>
                <a href={this.shareUrl()} className="fa fa-external-link" target="_blank" rel="noreferrer" > <span>Link</span> </a>
             </div>
          </div>
        );
    }
}